// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{box-sizing:border-box;padding:0;margin:0;font-family:"Inter","Helvetica","Arial",sans-serif}body{background:#fff3df}`, "",{"version":3,"sources":["webpack://./src/styles.scss"],"names":[],"mappings":"AAAA,EACI,qBAAA,CACA,SAAA,CACA,QAAA,CACA,kDAAA,CAGJ,KACI,kBAAA","sourcesContent":["*{box-sizing:border-box;padding:0;margin:0;font-family:\"Inter\",\"Helvetica\",\"Arial\",sans-serif}body{background:#fff3df}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
